import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useState } from 'react';
import { DatePicker } from 'rsuite';
import { generateDateInGenericStringFormat } from '../../../util';

const ReportingDialog = ({ open, gridApiRef, handleClose, selected_row }) => {
  const [equipmentId, setEquipmentId] = useState(selected_row?.machine_id);
  const date = new Date();
  const [time, set_time] = useState(generateDateInGenericStringFormat(date));
  const [remarks, setRemarks] = useState("");

  const [category, set_category] = useState("Equipment Malfunction");

  const handleChange = (e) => {
    set_category(e.target.value);
  };

  const handleConfirm = () => {
    if (remarks === "") {
      alert("remarks cannot be empty");
      return;
    }
    else {
      gridApiRef?.current?.confirm_update({ remarks, equipment_id: equipmentId, time, category });
      handleClose();
    }
  };

  return (
    <div><Dialog open={open} onClose={() => {
      gridApiRef?.current?.cancel_update();
      handleClose();
    }}
      sx={{ zIndex: 6 }}
    >
      <DialogTitle>Reporting {selected_row?.newValue}</DialogTitle>
      <DialogContent>
        {
          selected_row?.newValue === "Lab Event" && <>
            <div className='my-2'>
              <FormControl fullWidth>
                <InputLabel id="category-simple-select-label">Category</InputLabel>
                <Select
                  labelId="category-simple-select-label"
                  id="category-simple-select"
                  value={category}
                  label="Category"
                  onChange={handleChange}
                >
                  <MenuItem value={"Equipment Malfunction"}>Equipment Malfunction</MenuItem>
                  <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
              </FormControl>
            </div>
            {
              category === "Equipment Malfunction" &&
              <div>
                <TextField
                  autoFocus
                  margin="dense"
                  id="equipmentId"
                  label="Equipment ID"
                  type="text"
                  fullWidth
                  variant="standard"
                  value={equipmentId}
                  onChange={(e) => { setEquipmentId(e.target.value); }}
                />
                <div className="flex justify-between items-center my-3">
                  <div>
                    <label>Time of Event</label>
                  </div>
                  <div className='z-[10000000]'>
                    <DatePicker
                      format='yyyy-MM-dd HH:mm'
                      onChange={(value) => {
                        set_time(generateDateInGenericStringFormat(value));
                      }}
                      style={{
                      }}
                      className='z-[100000000]'
                      value={new Date(time)}
                    />
                  </div>
                </div>
              </div>
            }
          </>
        }
        <DialogContentText>
          Describe the details for {selected_row?.newValue} in remarks below.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="remarks"
          label="Remarks"
          type="text"
          fullWidth
          variant="standard"
          value={remarks}
          onChange={(e) => { setRemarks(e.target.value); }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          gridApiRef?.current?.cancel_update();
          handleClose();
        }}>Cancel</Button>
        <Button onClick={(handleConfirm)}>Update</Button>
      </DialogActions>
    </Dialog></div >
  );
};

export default ReportingDialog;